import { DatePipe, TitleCasePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import * as _ from "lodash";
import { NgxNumToWordsService, SUPPORTED_LANGUAGE } from "ngx-num-to-words";
import { FileUpload } from "primeng/fileupload";
import { Subject, lastValueFrom, takeUntil } from "rxjs";
import { PayTo, typeFinanceAddEditViewText } from "src/app/finance/constants/constants";
import { NewFileFolder } from "src/app/models/NewFileFolder";
import { AppMainService } from "src/app/app-main.service";
import { FinanceService } from "src/app/finance/finance.service";
import { PaymentmethodService } from "src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service";
import { PurchasesService } from "src/app/inventory/purchases/purchases.service";
import { SalesOrderService } from "src/app/inventory/sales-order/sales-order.service";
import { AppMainComponent } from "src/app/app.main.component";
import { LocalDatePipe } from "../../pipes/local-date.pipe";
import { FobpointService } from "src/app/configurations/inventory/setup/fobpoint/fobpoint.service";
import { SharedChannelService } from "../../services/channel.service";
import { CurrencyService } from "../../services/currency.service";
import { MyDocumentsService } from "src/app/profile/my-documents";
import { UtilsService } from "src/app/inventory/purchases/utility/utils.service";
import { FinanceUtilityService } from "src/app/finance/util/finance-utility.service";
import { AccountModuleId } from "../../constants/modules.constant";
import { ChannelN } from "../../models/channel.model";
import { Severity } from "src/app/inventory/constants/constants";
import { Status } from "src/app/configurations/finance/constants/constants";
import { TypeIds } from "src/app/inventory/sales-order/constants/constants";
import { uploadFiles, validateFiles } from "../../upload-files";
import { IExpense, IExpenseAttachmnet, IExpenseBundleProduct, IExpenseProduct, IExpenseTransactionOrderExpense } from "src/app/finance/models/expense.model";
import { ImportserialService } from "../../services/importserial.service";
import { GelAllAccountRequestModel } from "src/app/accounts-v2/models/account-request.model";
import { AccountServiceN } from "src/app/accounts-v2/services/account.services";
import { AccountFlatteningService } from "src/app/inventory/sales-order/services/account-flattening.service";
import { ClosingYearDisplayMessages } from "src/app/finance/constants/closing-year.constant";
import { UtilityService } from "src/app/inventory/sales-order/utils/utility.service";
import { IPostingPeriodDetails } from "../posting-period-selector/models/posting-period.model";
@Component({
    selector: "app-add-expense",
    templateUrl: "./add-expense.component.html",
    styleUrls: ["./add-expense.component.scss"],
})
export class AddExpenseComponent implements OnInit, OnChanges, OnDestroy {
    @Input() displayAddEditExpense;
    @Input() expenseId: number;
    @Input() type: typeFinanceAddEditViewText;
    @Input() isShowVoidDelete : boolean = true;
    @Input() isEditableViewDialog : boolean = true;
    @Output() close = new EventEmitter();
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    endingBalance;
    payToName;
    index = 0;
    expensesTB = [];
    itemsTB = [];
    documentsList: any[] = [];
    financialAccounts = [];
    assetAccounts = [];
    allPaymentMethods = [];
    displayAddPayto = false;
    payTo: string = PayTo.Vendor;
    allVendorsDD = [];

    allVendors: any[] = [];
    selectedVendorDD;
    selectedEmployee;
    selectedVendor;
    vendorDetails;
    ordersVendorAddr = "";
    ordersVendorCity = "";
    ordersVendorState = "";
    ordersVendorCountry = "";
    ordersVendorZipcode = "";
    ordersVendorPhone = "";
    ordersVendorContact = "";
    ordersVendorAddrNew = "";
    ordersVendorCityNew = "";
    ordersVendorStateNew = "";
    ordersVendorCountryNew = "";
    ordersVendorZipcodeNew = "";
    ordersVendorPhoneNew = "";
    ordersVendorContactNew = "";
    displayVendorAddress = false;
    activeVendorAddresses: any[] = [];
    selectedVendorAddress;
    selectedVendorContact;
    displayVendorContact: boolean = false;
    orderVendorContactId: number;
    isClickVendorAddress = false;
    selectedAddress;

    //account
    accountChannels = [];
    selectedChannel;
    allAccountsDD = [];
    accountInfo;
    accountAddressInfo;
    accountAddressInfoNew;
    billingAddressContact;
    selectedAccountAddress;
    displayAccountAddress = false;
    selectedContact;
    contactSelectionModalType: typeFinanceAddEditViewText = "";
    displayContactSelectionModal = false;
    selectedAccountContact;
    selectedAccount;
    selectedAccountId: number

    //expense and items
    expenseHeader;
    displayAddExpense = false;
    accountForm: FormGroup;
    expenses = [];
    items = [];
    amountItem: number = 0;
    subTotal: number = 0;
    shippingAmount: number = 0;
    discount: number = 0;
    valueOptions: any[] = [];
    selectedValueOption = this.valueOptions[0];
    discountAmount: number = 0;
    amountExpense: number = 0;
    isBundle: boolean = false;
    selectedBundle;
    first: number = 0;
    pageNumber: number = 1;
    pageSize: number = 15;

    expenseForm: FormGroup;

    // product add
    displayProductSelectionModal;
    moduleName;
    headerText;
    isVisibleLocation = true;
    selectedLocation;
    selectedProductsList: any[] = [];
    allDiscounts = [];
    allFOBPoints = [];

    currencySymbol = "";
    numberInWords: string;
    lang: SUPPORTED_LANGUAGE = "en";

    expenseDetails: IExpense;
    
    // attachment
    MAX_SIZE = 26314400;
    uploadedFiles = [];
    newFileList = [];
    saveBtn: string = "";
    totalFileSize = 0;
    fileList: File[] = [];
    files = [];
    displayNewUpload = false;
    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif", ".txt", ".xls", ".xlsx", "csv", ".doc", ".docx", ".ppt", ".pptx", "pdf"];
    newFileFolder: NewFileFolder = new NewFileFolder();
    selectedLocationId: number = 0;
    selectDefaultLocation: boolean = true;
    isVoided: boolean = false;
    displayFilePreview: boolean = false;
    currentFile: any = null;

    // fraction digits
    fractionDigits: number = 0;
    qtyFractionDigits: number = 0;

    statementMessage: string = "";
    allUser :any[] = [];
    isAllowPostingPeriod: boolean = false;
    currentPostingPeriodInfo: IPostingPeriodDetails;
    updatedPostingPeriodInfo: IPostingPeriodDetails;
    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        public appMainService: AppMainService,
        private financeService: FinanceService,
        private paymentMethodService: PaymentmethodService,
        private purchaseService: PurchasesService,
        private salesOrderService: SalesOrderService,
        private fb: FormBuilder,
        public app: AppMainComponent,
        public datePipe: DatePipe,
        public localDatePipe: LocalDatePipe,
        private fobService: FobpointService,
        private sharedChannelService: SharedChannelService,
        private currencyService: CurrencyService,
        private ngxNumToWordsService: NgxNumToWordsService,
        private documentService: MyDocumentsService,
        public utilService: UtilsService, private accountServiceN: AccountServiceN,
        private financeUtilityService: FinanceUtilityService,
        private importService: ImportserialService,
        private accountFlatteningService: AccountFlatteningService,
        private utilityService: UtilityService,
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayAddEditExpense && changes.displayAddEditExpense.currentValue) {
            this.displayAddEditExpense = changes.displayAddEditExpense.currentValue;
            this.getIsetting();
            this.initData();
        }
        if (changes.expenseId && changes.expenseId.currentValue) {
            this.expenseId = changes.expenseId.currentValue;
            if (this.expenseId) {
                this.getExpenseDetailsById(this.expenseId);
            }
        }
    }
    ngOnInit(): void {
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.initexpenseForm();
        this.initAccountForm();

        this.getAllDiscounts();
        this.getAccountChannels(AccountModuleId);
        this.loadFOBList();
        this.getAllUsers();


        //get discount type
        this.purchaseService
            .getAllInventoryGroups()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                const groupId = res.filter((r) => r?.name == "Discount Type")[0]?.id;
                this.getGroupById(groupId);
            });

        this.initexpenseForm();
        this.initAccountForm();
        this.currencySymbol = this.currencyService.currencySymbolValue;
    }
    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    initData() {
        this.initexpenseForm();
        this.initAccountForm();
        this.loadFinancialAccounts();
        this.loadPaymentMethod();
        this.loadAllVendor();

        this.expenses = [];
        this.items = [];
        this.amountExpense = 0;
        this.documentsList = [];
        this.endingBalance = 0;
        this.amountItem = 0;
        this.subTotal = 0;
        this.initAccountInfo();
        this.initVendorInfo();
    }
    initAccountInfo() {
        this.accountInfo = null;
        this.accountAddressInfo = null;
        this.billingAddressContact = null;
        this.selectedAccount = null;
    }
    initVendorInfo() {
        this.payToName = "";
        this.activeVendorAddresses = [];
        this.selectedVendorDD = null;
        this.ordersVendorAddr = "";
        this.ordersVendorState = "";
        this.ordersVendorCity = "";
        this.ordersVendorZipcode = "";
        this.ordersVendorCountry = "";
        this.ordersVendorContact = "";
        this.vendorDetails = null;
        this.ordersVendorPhone = null;
    }

    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => { },
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }

    getAllUsers(type?) {
        this.salesOrderService.getAllUser().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                this.allUser = resp;
                if (type == "VIEW" || type == 'EDIT') {
                    this.selectedEmployee = this.allUser?.find(x => x.id == this.expenseDetails?.employeeId);
                }
            });
    }

    getAccountChannels(id: number) {
        this.sharedChannelService
            .getChannels(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (res: ChannelN[]) => {
                    this.accountChannels = res;
                    this.selectedChannel = this.accountChannels.filter((ac) => ac.isDefault == true)[0];
                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }

    initexpenseForm() {
        this.expenseForm = this.fb.group({
            id: [0],
            expenseFinancialAccountId: ["", Validators.required],
            paymentMethodId: ["", Validators.required],
            referenceNo: ["", Validators.required],
            checkDate: [this.app._showDateTimeWithZone(new Date()), Validators.required],
            amount: ["", Validators.required],
            amountInWords: ["", Validators.required],
            memo: [""],
            freight: [0],
            discountAmount: [0],
            discountType: [""],
        });
    }
    initAccountForm() {
        this.accountForm = this.fb.group({
            id: [0],
            financialAccountId: [null, [Validators.required]],
            amount: ["", [Validators.required]],
            memo: [""],
        });
    }

    async getExpenseDetailsById(id: number) {
        this.documentsList = [];
        this.financeService
            .getExpenseDetailsById(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: async (res) => {
                    this.expenseDetails = res;
                    this.isVoided = res?.isVoided
                    this.selectedAccountId = res?.accountId
                    if (this.expenseDetails.accountId) {
                        this.accountInfo = await this.salesOrderService.getAccountDetailsById(this.expenseDetails.accountId);
                        this.selectedAccount = this.accountInfo;
                        this.selectedAccount["nameWithSequenceNumber"] = this.accountInfo?.["sequenceNumber"] + "-" + this.accountInfo?.['businessName'];
                    }

                    this.setPayToName(this.expenseDetails, this.type);
                    const accounts = await lastValueFrom(this.financeService.getAllFinancialAccounts(false));
                    this.filterAssetAccount(accounts);
                    let selectedAcc = this.financeUtilityService.findRecursiveChildObjects(this.assetAccounts, this.expenseDetails?.expenseFinancialAccountId);
                    this.getEndingBalance(this.expenseDetails?.expenseFinancialAccountId);
                    let groups = await lastValueFrom(this.purchaseService.getAllInventoryGroups());
                    let groupId = groups.filter((r) => r?.name == "Discount Type")[0].id;
                    this.valueOptions = await lastValueFrom(this.purchaseService.getGroupById(groupId));
                    this.selectedValueOption = this.valueOptions?.find((v) => v.id == this.expenseDetails?.discountTypeId);

                    this.expenseForm.patchValue({
                        ...this.expenseDetails,
                        amount: parseFloat(Number(this.expenseDetails.amount).toFixed(this.fractionDigits)),
                        checkDate: this.app._showDateTimeWithZone(this.expenseDetails?.checkDate),
                        expenseFinancialAccountId: selectedAcc,
                    });
                    this.currentPostingPeriodInfo = {
                        postingDate: this.expenseDetails?.postingDate,
                        postingMonth: this.expenseDetails?.postingMonth,
                        postingYear: this.expenseDetails?.postingYear
                    };
                    this.setExpenseData();

                    if (this.type == 'VIEW') {
                        this.expenseForm.disable();
                    }
                    else if (this.type == 'EDIT') {
                        this.expenseForm.enable();
                        this.setEditExpenceTreeValue(this.expenses);
                    }
                    else {
                        this.expenseForm.enable();
                    }
                    this.setProductsData(this.type);
                    this.setAttachmentsData();

                },
                error: (error) => {
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred...",
                    });
                },
            });
    }
    setPayToName(expenseDetails, type: typeFinanceAddEditViewText) {
        if(expenseDetails?.employeeId != 0){
            this.payTo = PayTo.Employee;
                this.getAllUsers( type);
        }else if (expenseDetails?.vendorId == 0 && expenseDetails?.accountId == 0) {
            this.payTo = PayTo.Other;
        } else if (expenseDetails?.vendorId != 0) {
            this.payTo = PayTo.Vendor;
            this.getSelectedVendorDetails(this.expenseDetails?.vendorId, type);
        } else {
            this.payTo = PayTo.Customer;
        }
        this.payToName = this.payTo == PayTo.Other ? "Other" : this.expenseDetails?.businessName;
    }
    setExpenseData() {
        this.expenses = this.expenseDetails?.expenseTransactionOrderExpense;
        this.calculateExpense();
    }
    setProductsData(type?: typeFinanceAddEditViewText) {
        let products = [];
        this.expenseDetails?.expenseTransactionOrderProduct?.forEach((product) => {
            let data = {
                id: product?.productId || 0,
                warehouseId: product?.warehouseId || 0,
                typeId: product?.typeId || 0,
                itemNo: product?.itemNo || "",
                description: product?.description || "",
                ordQty: product?.quantity || 1,
                price: product?.pricePerProduct || 0,
                costPrice: product?.pricePerProduct || 0,
                cost: product?.totalAmount || 0,
                expenseTransactionOrderProductId: product?.id || 0,
                expenseTransactionId: product?.expenseTransactionId || 0,
                bundleDetails: this.setBankTransactionOrderBundleProductsData(product, type),
                expenseTransactionOrderProductBundleId: 0,
            };
            products.push(data);
        });
        this.items = products;
        this.calculateItemExpense(type);
    }
    setAttachmentsData() {
        this.documentsList = this.expenseDetails.expenseTransactionAttachment?.map((a) => ({ ...a, attachmentName: a.fileName, uploadedDate: a.createdDate }));
    }

    loadAllVendor() {
        this.appMainService.isShowSpinner("loadvendor");
        this.purchaseService
            .getAllPOVendors()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (vendor) => {
                    this.allVendorsDD = vendor?.filter((vendor) => vendor?.isActive == true);
                    this.appMainService.isHideSpinner("loadvendor");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadvendor");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    loadPaymentMethod() {
        this.appMainService.isShowSpinner("loadpaymentmethod");
        this.paymentMethodService
            .getPaymentMrthodList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (methods) => {
                    this.allPaymentMethods = methods;
                    this.appMainService.isHideSpinner("loadpaymentmethod");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadpaymentmethod");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    loadFinancialAccounts() {
        this.appMainService.isShowSpinner("loadaccounts");
        this.financeService
            .getAllFinancialAccounts(false)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (accounts) => {
                    let acc = JSON.parse(JSON.stringify(accounts));
                    this.filterAssetAccount(acc);
                    this.appMainService.isHideSpinner("loadaccounts");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadaccounts");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    filterAssetAccount(accounts) {
        this.financialAccounts = this.financeUtilityService.prepareFinancialAccountsData(accounts);
        this.assetAccounts = [this.financialAccounts?.find((a) => a?.name?.toLowerCase() == "assets")];
    }

    voidOrDelete(isVoid: boolean) {
        if (!!this.statementMessage) {
            this.messageService.add({ severity: Severity.Warn, summary: this.titlecasePipe.transform(Severity.Warn), detail: ClosingYearDisplayMessages.voidDeleteMessage });
        } else {
            this.confirmVoidDelete(isVoid);
        }
    }

    confirmVoidDelete(isVoid: boolean) {
        const isVoidStatus = isVoid ? 'Void' : 'Delete'
        this.confirmationService.confirm({
            message: `Do you want to ${isVoidStatus} this Expence?`,
            header: `${isVoidStatus} Confirmation`,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.financeService.bankEntriesVoidDelete(this.expenseId, isVoid, 'RemoveExpense', 'expenseId').subscribe(resp => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: `${isVoidStatus}${isVoid ? 'ed' : 'd'} Successfully...`,
                    });
                    this.onClose("edit");
                })
            },
        });
    }

    prepareCreditCardAttachment() {
        let attachments: IExpenseAttachmnet[] = [];
        this.documentsList?.forEach((document) => {
            const attachment: IExpenseAttachmnet = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                expenseTransactionId: 0,
                attachmentId: document?.attachmentId || 0,
                organizationId: this.app.companyId,
                statusId: Status.ACTIVE,
                fileName: document?.attachmentName || "",
            };
            attachments.push(attachment);
        });
        return attachments;
    }
    prepareBankTransactionOrderBundleProductsData(bPoduct, type: typeFinanceAddEditViewText) {
        let bankTransactionOrderBundleProducts: IExpenseBundleProduct[] = [];
        bPoduct?.bundleDetails?.forEach((item) => {
            let uomValue = item.unit?.uomDetail?.value || 1;
            let bankTransactionOrderBundleProduct: IExpenseBundleProduct = {
                id: type == "EDIT" ? item?.expenseTransactionOrderProductBundleId || 0 : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                expenseTransactionId: type == "EDIT" ? this.expenseDetails?.id || 0 : 0,
                productId: bPoduct?.id || 0,
                productUnitId: item?.uom?.id || 0,
                quantity: item?.ordQty || 0,
                pricePerProduct: item.costPrice,
                totalAmount: item.ordQty * item.costPrice * uomValue,
                binId: 0,
                statusId: Status.ACTIVE,
                warehouseId: this.selectedLocation?.id || 0,
                discountId: 0,
                discountTypeId: 0,
                discountAmount: 0,
                typeId: item?.typeId || 0,
                assetAccountId: 0,
                expenseTransactionOrderProductId: type == "EDIT" ? item?.expenseTransactionOrderProductId || 0 : 0,
                subProductId: item?.id || 0,
            };
            bankTransactionOrderBundleProducts.push(bankTransactionOrderBundleProduct);
        });
        return bankTransactionOrderBundleProducts;
    }
    prepareCreditCardProductsData(type: typeFinanceAddEditViewText) {
        let bankTransactionOrderProducts: IExpenseProduct[] = [];
        this.items?.forEach((item) => {
            let uomValue = item.unit?.uomDetail?.value || 1;
            let bankTransactionOrderProduct: IExpenseProduct = {
                id: type == "EDIT" ? item?.expenseTransactionOrderProductId || 0 : 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                expenseTransactionId: type == "EDIT" ? this.expenseDetails?.id || 0 : 0,
                productId: item?.id || 0,
                productUnitId: item?.uom?.id || 0,
                quantity: item?.ordQty || 0,
                pricePerProduct: item.costPrice,
                totalAmount: item.typeId == TypeIds.BundleTypeId ? item.cost : item.ordQty * item.costPrice * uomValue,
                binId: 0,
                statusId: Status.ACTIVE,
                warehouseId: type == 'EDIT' ? item?.warehouseId || 0 : this.selectedLocation?.id || 0,
                discountId: 0, // ???
                discountTypeId: 0, // ???
                discountAmount: 0, // ???
                typeId: item?.typeId || 0,
                assetAccountId: 0, // todo later
                expenseTransactionOrderBundleProduct: this.prepareBankTransactionOrderBundleProductsData(item, type),
            };
            bankTransactionOrderProducts.push(bankTransactionOrderProduct);
        });
        return bankTransactionOrderProducts;
    }
    prepareCreditCardExpenseData() {
        let creditCardExpenses: IExpenseTransactionOrderExpense[] = [];
        this.expenses?.forEach((expense) => {
            let bankTransactionOrderExpense: IExpenseTransactionOrderExpense = {
                id: 0,
                createdSource: this.app.userIP,
                updatedSource: this.app.userIP,
                createdBy: this.app.user.userId,
                updatedBy: this.app.user.userId,
                createdDate: this.app._saveDateTimeWithZone(new Date()),
                updatedDate: this.app._saveDateTimeWithZone(new Date()),
                financialAccountId: expense?.financialAccountId?.value?.id || 0,
                amount: expense?.amount || 0,
                memo: expense?.memo || "",
                classId: 0, // todo later
                expenseTransactionId: 0,
                statusId: Status.ACTIVE,
            };
            creditCardExpenses.push(bankTransactionOrderExpense);
        });
        return creditCardExpenses;
    }

    saveExpenseData() {
        let fobPoint = this.allFOBPoints?.find((fp) => fp.isDefault == true);
        this.expenseForm.markAllAsTouched();
        this.expenseForm.markAsDirty();
        if (!!this.statementMessage) {
            return;
        }
        if (this.expenseForm?.controls?.expenseFinancialAccountId?.valid && this.expenseForm?.controls?.paymentMethodId?.valid) {
            //Edit
            if (this.type == 'EDIT' && this.expenseDetails?.id > 0) {
                let expenseObj: IExpense = {
                    id: this.expenseDetails.id,
                    createdSource: this.expenseDetails?.createdSource ?? this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.expenseDetails?.createdBy ?? this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.expenseDetails?.createdDate ?? this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    organizationId: this.expenseDetails?.organizationId > 0 ? this.expenseDetails?.organizationId : this.app.companyId,
                    expenseFinancialAccountId: this.expenseForm.controls.expenseFinancialAccountId?.value?.value?.id || 0,
                    referenceNo: this.expenseForm.controls.referenceNo.value,
                    checkDate: this.app._saveDateTimeWithZone(this.expenseForm.controls.checkDate.value),
                    amount: this.expenseForm.controls.amount.value,
                    addressId: this.payTo == PayTo.Vendor ? this.selectedAddress?.id || 0 : this.payTo == PayTo.Customer ? this.accountAddressInfo?.address?.id || 0 : 0,
                    accountId: this.payTo == PayTo.Customer ? this.selectedAccount?.id || this.selectedAccountId || 0 : 0,
                    vendorId: this.payTo == PayTo.Vendor ? this.selectedVendorDD?.id || 0 : 0,
                    employeeId: this.payTo == PayTo.Employee ? this.selectedEmployee?.id || 0 : 0,
                    amountInWords: this.expenseForm.controls.amountInWords.value,
                    memo: this.expenseForm.controls.memo.value,
                    warehouseId: this.expenseDetails?.warehouseId || 0,
                    channelId: this.selectedChannel?.id || 0,
                    statusId: Status.ACTIVE,
                    discountId: 0,
                    discountTypeId: this.expenseForm.controls.discountType.value.id || 0,
                    discountAmount: this.discount,
                    freight: this.expenseForm.controls.freight.value,
                    freightFinancialAccountId: fobPoint?.financialAccountId || 0,
                    isPrint: false,
                    isRefund: false,
                    paymentMethodId: this.expenseForm.controls.paymentMethodId.value || 0,
                    expenseTransactionOrderProduct: this.prepareCreditCardProductsData(this.type),
                    expenseTransactionOrderExpense: this.prepareCreditCardExpenseData(),
                    discountFinancialId: this.allDiscounts?.filter((discount) => discount.discountBy == this.expenseForm?.controls?.discountType?.value?.id).map((value) => value.incomeAccount)[0],
                    expenseTransactionAttachment: this.prepareCreditCardAttachment(),
                    postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.expenseDetails?.postingDate,
                    postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : this.expenseDetails?.postingMonth,
                    postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : this.expenseDetails?.postingYear,
                };
                if (expenseObj?.expenseTransactionOrderExpense?.length == 0 && expenseObj?.expenseTransactionOrderProduct?.length == 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: this.titlecasePipe.transform('Warning'),
                        detail: "At least one Expense/Items is required",
                    });
                    return;
                }
                this.appMainService.isShowSpinner("savebankentries");
                this.financeService
                    .editExpense(expenseObj)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Successfully updated ...",
                            });
                            this.onClose("edit");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred while updating ...",
                            });
                        },
                    });
            }
            else {
                let expenseObj: IExpense = {
                    id: 0,
                    createdSource: this.app.userIP,
                    updatedSource: this.app.userIP,
                    createdBy: this.app.user.userId,
                    updatedBy: this.app.user.userId,
                    createdDate: this.app._saveDateTimeWithZone(new Date()),
                    updatedDate: this.app._saveDateTimeWithZone(new Date()),
                    organizationId: this.app.companyId,
                    expenseFinancialAccountId: this.expenseForm.controls.expenseFinancialAccountId?.value?.value?.id || 0,
                    referenceNo: this.expenseForm.controls.referenceNo.value,
                    checkDate: this.app._saveDateTimeWithZone(this.expenseForm.controls.checkDate.value),
                    amount: this.expenseForm.controls.amount.value,
                    addressId: this.payTo == PayTo.Vendor ? this.selectedAddress?.id || 0 : this.payTo == PayTo.Customer ? this.accountAddressInfo?.address?.id || 0 : 0,
                    accountId: this.selectedAccount?.id || 0,
                    vendorId: this.selectedVendorDD?.id || 0,
                    employeeId: this.selectedEmployee?.id || 0,
                    amountInWords: this.expenseForm.controls.amountInWords.value,
                    memo: this.expenseForm.controls.memo.value,
                    warehouseId: this.selectedLocation?.id || 0,
                    channelId: this.selectedChannel?.id || 0,
                    statusId: Status.ACTIVE,
                    discountId: 0,
                    discountTypeId: this.expenseForm.controls.discountType.value.id || 0,
                    discountAmount: this.discount,
                    freight: this.expenseForm.controls.freight.value,
                    freightFinancialAccountId: fobPoint?.financialAccountId || 0,
                    isPrint: false,
                    isRefund: false,
                    paymentMethodId: this.expenseForm.controls.paymentMethodId.value || 0,
                    expenseTransactionOrderProduct: this.prepareCreditCardProductsData(this.type),
                    expenseTransactionOrderExpense: this.prepareCreditCardExpenseData(),
                    discountFinancialId: this.allDiscounts?.filter((discount) => discount.discountBy == this.expenseForm?.controls?.discountType?.value?.id).map((value) => value.incomeAccount)[0],
                    expenseTransactionAttachment: this.prepareCreditCardAttachment(),
                    postingDate: this.isAllowPostingPeriod ? this.app._saveDateTimeWithZone(this.updatedPostingPeriodInfo?.postingDate) : this.app._saveDateTimeWithZone(this.expenseForm?.controls?.checkDate?.value),
                    postingMonth: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingMonth : new Date(this.expenseForm?.controls?.checkDate?.value).getMonth() + 1,
                    postingYear: this.isAllowPostingPeriod ? this.updatedPostingPeriodInfo?.postingYear : new Date(this.expenseForm?.controls?.checkDate?.value).getFullYear(),
                };
                if (expenseObj?.expenseTransactionOrderExpense?.length == 0 && expenseObj?.expenseTransactionOrderProduct?.length == 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: this.titlecasePipe.transform('Warning'),
                        detail: "At least one Expense/Items is required",
                    });
                    return;
                }
                this.appMainService.isShowSpinner("savebankentries");
                this.financeService
                    .saveExpense(expenseObj)
                    .pipe(takeUntil(this.ngUnsubscribe$))
                    .subscribe({
                        next: (data) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Success,
                                summary: this.titlecasePipe.transform(Severity.Success),
                                detail: "Saved Successfully ...",
                            });
                            this.onClose("save");
                        },
                        error: (error) => {
                            this.appMainService.isHideSpinner("savebankentries");
                            this.messageService.add({
                                severity: Severity.Error,
                                summary: this.titlecasePipe.transform(Severity.Error),
                                detail: "Error occurred ...",
                            });
                        },
                    });
            }
        }
    }

    getEndingBalance(id) {
        this.appMainService.isShowSpinner("loadendbalance");
        this.financeService
            .getEndingBalance(id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (data) => {
                    this.appMainService.isHideSpinner("loadendbalance");
                    this.endingBalance = data;
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("loadendbalance");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }

    onChangeBankAccount(e) {
        this.getEndingBalance(e?.node?.value?.id);
    }

    addPayTo() {
        this.displayAddPayto = true;
    }
    cancelPayTo() {
        if (!this.payToName) {
            this.initAccountInfo();
            this.initVendorInfo();
        }
        this.displayAddPayto = false;
    }

    savePayto() {
        if (this.payTo == PayTo.Vendor) {
            this.payToName = this.selectedVendorDD?.name ?? "";
            this.ordersVendorAddrNew = this.ordersVendorAddr;
            this.ordersVendorCityNew = this.ordersVendorCity;
            this.ordersVendorStateNew = this.ordersVendorState;
            this.ordersVendorCountryNew = this.ordersVendorCountry;
            this.ordersVendorZipcodeNew = this.ordersVendorZipcode;
            this.ordersVendorPhoneNew = this.ordersVendorPhone;
            this.ordersVendorContactNew = this.ordersVendorContact;
        } else if (this.payTo == PayTo.Customer) {
            this.payToName = this.accountInfo.businessName;
            this.accountAddressInfoNew = this.accountAddressInfo;
        } else if (this.payTo == PayTo.Employee) {
            this.payToName = this.selectedEmployee?.name ?? '';
        } else if (this.payTo == PayTo.Other) {
            this.payToName = "Other";
        }
        this.displayAddPayto = false;
    }
    getSelectedVendorDetails(vendorId, type?) {
        this.appMainService.isShowSpinner("vendor");
        this.purchaseService
            .getVendorById(vendorId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                this.vendorDetails = value;
                if (type == "VIEW" || type == 'EDIT') {
                    this.selectedVendorDD = this.allVendorsDD?.find(x => x.id == vendorId);
                }
                this.appMainService.isHideSpinner("vendor");
                this.onChangeVendor(value, type);
            });
    }
    onChangeVendor(value, type?) {
        this.isClickVendorAddress = false;
        this.activeVendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == 1); //Active Address
        if (type == "VIEW") {
            this.activeVendorAddresses = value.vendorAddresses?.filter((add) => add.addressId == this.expenseDetails?.addressId);
        }
        if (this.activeVendorAddresses.length == 1) {
            this.selectedAddress = this.activeVendorAddresses[0].address;
            this.ordersVendorAddr = this.activeVendorAddresses[0].address?.streetAddress1 == "" ? this.activeVendorAddresses[0].address?.streetAddress2 : this.activeVendorAddresses[0].address?.streetAddress1 + "," + this.activeVendorAddresses[0].address?.streetAddress2;
            this.ordersVendorCity = this.activeVendorAddresses[0]?.address?.city?.name ?? "";
            this.ordersVendorState = this.activeVendorAddresses[0]?.address?.state?.name ?? "";
            this.ordersVendorCountry = this.activeVendorAddresses[0]?.address?.country?.name ?? "";
            this.ordersVendorZipcode = this.activeVendorAddresses[0].address?.zipCode;
            if (this.activeVendorAddresses[0].address.attnContactId) {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contactId == this.activeVendorAddresses[0].address.attnContactId) {
                        this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            } else {
                for (let vendorContact of value.vendorContacts) {
                    if (vendorContact.contact?.isPrimaryContact) {
                        this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                        this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    }
                }
            }
        } else if (this.activeVendorAddresses.length > 1) {
            this.selectedVendor = value;
            this.selectedVendor.vendorAddresses = value.vendorAddresses?.filter((add) => add.statusId == 1); //Active Address
            this.displayVendorAddress = type === 'show_list';
        } else {
            this.ordersVendorAddr = "";
            this.ordersVendorCity = "";
            this.ordersVendorState = "";
            this.ordersVendorCountry = "";
            this.ordersVendorZipcode = "";
            this.ordersVendorPhone = "";
            this.ordersVendorContact = "";
            for (let vendorContact of value.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        }
    }
    onRowSelectAddress(value) {
        this.selectedAddress = this.selectedVendorAddress.address;
        this.displayVendorAddress = false;
        this.ordersVendorAddr = this.selectedVendorAddress.address?.streetAddress1 == "" ? this.selectedVendorAddress.address?.streetAddress2 : this.selectedVendorAddress.address?.streetAddress1 + " " + this.selectedVendorAddress.address?.streetAddress2;
        this.ordersVendorCity = this.selectedVendorAddress?.address?.city?.name ?? "";
        this.ordersVendorState = this.selectedVendorAddress?.address?.state?.name ?? "";
        this.ordersVendorCountry = this.selectedVendorAddress?.address?.country?.name ?? "";
        this.ordersVendorZipcode = this.selectedVendorAddress.address?.zipCode;

        if (this.selectedVendorAddress.address.attnContactId) {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contactId == this.selectedVendorAddress.address.attnContactId) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        } else {
            for (let vendorContact of this.vendorDetails?.vendorContacts) {
                if (vendorContact.contact?.isPrimaryContact) {
                    this.ordersVendorPhone = vendorContact.contact?.contactPhones[0]?.phone?.number;
                    this.ordersVendorContact = vendorContact.contact?.firstName + " " + vendorContact.contact?.lastName;
                    this.orderVendorContactId = vendorContact.contactId;
                }
            }
        }

        this.payToName = this.selectedVendorDD?.name ?? "";
        this.ordersVendorAddrNew = this.ordersVendorAddr;
        this.ordersVendorCityNew = this.ordersVendorCity;
        this.ordersVendorStateNew = this.ordersVendorState;
        this.ordersVendorCountryNew = this.ordersVendorCountry;
        this.ordersVendorZipcodeNew = this.ordersVendorZipcode;
        this.ordersVendorPhoneNew = this.ordersVendorPhone;
        this.ordersVendorContactNew = this.ordersVendorContact;
    }
    changeVendorContact() {
        this.selectedVendorContact = null;
        this.selectedVendorContact = this.vendorDetails?.vendorContacts?.filter((contact) => contact.contactId == this.orderVendorContactId)[0];
        this.displayVendorContact = true;
    }
    onRowSelectContactVendor() {
        this.ordersVendorPhone = this.selectedVendorContact.contact?.contactPhones[0]?.phone?.number;
        this.orderVendorContactId = this.selectedVendorContact.contactId;
        this.ordersVendorContact = this.selectedVendorContact.contact?.firstName + " " + this.selectedVendorContact.contact?.lastName;
        this.displayVendorContact = false;
    }
    //account
    async selectAccount(c) {
        this.accountInfo = null;
        this.billingAddressContact = null;
        this.accountAddressInfo = null;

        this.appMainService.isShowSpinner("loadOrderAccountsAddress");
        this.accountInfo = await this.salesOrderService.getAccountDetailsById(c.id);

        this.appMainService.isHideSpinner("loadOrderAccountsAddress");

        // default billing and shipping address
        if (this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0) {
            const allBillAddress = this.accountInfo.accountAddresses.filter(
                (a) => a.address?.addressTypeId == 190, //billingAddress id
            );
            this.accountAddressInfo = allBillAddress ? allBillAddress.filter((b) => b.address?.isDefault == true)[0] : null;
            this.selectedAccountAddress = this.accountAddressInfo;
        }

        //billing contact
        if (this.accountAddressInfo) {
            if (this.accountAddressInfo.address && this.accountAddressInfo.address.attnContactId) {
                this.billingAddressContact = this.accountAddressInfo.address.attnContact;
            } else {
                if (this.accountInfo && this.accountInfo.accountContacts) {
                    this.accountInfo.accountContacts.forEach((e) => {
                        if (e.isPrimaryContact) {
                            this.billingAddressContact = e?.contact;
                        }
                    });
                }
            }
        }

        this.displayAccountAddress = this.accountInfo && this.accountInfo.accountAddresses && this.accountInfo.accountAddresses.length > 0 && !this.accountAddressInfo ? true : false;
    }
    editAccountAddress() {
        this.displayAccountAddress = true;
    }

    onRowSelectBillingAddress(e) {
        this.displayAccountAddress = false;
        this.accountAddressInfo = JSON.parse(JSON.stringify(this.selectedAccountAddress));

        if (this.accountAddressInfo && this.accountAddressInfo?.address && this.accountAddressInfo?.address?.attnContactId) {
            this.billingAddressContact = this.accountAddressInfo?.address?.attnContact;
        } else {
            if (this.accountInfo && this.accountInfo.accountContacts) {
                this.accountInfo.accountContacts.forEach((e) => {
                    if (e.isPrimaryContact) {
                        this.billingAddressContact = e?.contact;
                    }
                });
            }
        }
    }
    openContactSelectionModal(e) {
        for (let s of this.accountInfo?.accountContacts) {
            if (s.contact.id == this.billingAddressContact.id) {
                this.selectedAccountContact = s;
            }
        }
        this.contactSelectionModalType = e;
        this.displayContactSelectionModal = true;
    }
    onRowSelectContactAccount(e) {
        this.displayContactSelectionModal = false;
        this.billingAddressContact = e?.data.contact;
    }
    onChangeAccountChannel() {
        this.selectedAccount = null;
    }
    filterAccount(event) {
        if (!event.query.toLowerCase()) {
            this.allAccountsDD = [];
            return;
        }
        const typeId = this.selectedChannel?.id;
        this.appMainService.isShowSpinner('getAccountList');
        this.accountServiceN.getAccountsByNameWithHierarchy(typeId, event.query.toLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (response) => {
                    if (response) {
                        this.allAccountsDD = this.accountFlatteningService.flattenAccounts(response);
                    }
                    this.appMainService.isHideSpinner('getAccountList');
                },
                error: (error) => {
                    this.appMainService.isHideSpinner('getAccountList');
                },
                complete: () => {
                    this.appMainService.isHideSpinner('getAccountList');

                }
            })

    }

    addExpense() {
        this.expenseHeader = "Add Expense";
        this.initAccountForm();
        this.displayAddExpense = true;
    }

    editExpense(data) {
        this.expenseHeader = "Edit Expense";
        this.initAccountForm();
        this.accountForm.patchValue({ ...data });
        this.displayAddExpense = true;
    }

    saveExpense(value) {
        if (value && value.id) {
            this.expenses?.forEach((e) => {
                if (e.id == value.id) {
                    e.financialAccountId = value.financialAccountId;
                    e.amount = value.amount;
                    e.memo = value.memo;
                }
            });
        } else {
            value["id"] = this.expenses?.length + 1;
            this.expenses.push(value);
        }
        this.calculateExpense();
        this.displayAddExpense = false;
    }

    calculateExpense() {
        this.amountExpense = 0;
        for (let exp of this.expenses) {
            this.amountExpense = this.amountExpense + exp.amount;
        }
        this.setAmountValue();
    }

    // attchment upload
    addUpload() {
        this.saveBtn = "upload";
        this.removeAllFiles();
        this.displayNewUpload = true;
    }
    removeAllFiles() {
        this.fileList = [];
        this.newFileList = [];
        this.files = [];
        this.totalFileSize = 0;
    }
    getFileIcon(fileName: string): string {
        const seperationIndex = fileName.lastIndexOf(".");
        const extension = fileName.substring(seperationIndex + 1).toLowerCase();
        return `assets/icons/${extension}.png`;
    }
    uploadAttachments(files: File[]) {
        this.uploadedFiles = files;
        this.appMainService.isShowSpinner("upload");

        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 25, this.allowedExtensions);

                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }

                    this.appMainService.isHideSpinner("upload");
                } else {
                    this.newFileList.push(file);
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        this.totalFileSize += size;
                        this.appMainService.isHideSpinner("upload");
                    });
                }
            }
        } else {
            this.messageService.add({ severity: "error", summary: "Error", detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }
    }
    createUpdateFolderFiles() {
        if (this.totalFileSize > this.MAX_SIZE) {
            this.messageService.add({
                severity: "warn",
                summary: "Maximum Upload Size Limit Exceeded",
                detail: "Maximum upload size is 25MB!",
            });
            return;
        }

        const formData = this.setFormData(this.newFileList);
        formData.append("ModuleNameWithDisplayOrder", "FinanceCreditCard-1");

        this.appMainService.isShowSpinner("uplaodFile");
        this.documentService
            .uploadFilesByOrganization(formData)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (data) => {
                    this.documentsList.push(...data);
                    this.displayNewUpload = false;
                    this.appMainService.isHideSpinner("uplaodFile");
                    this.messageService.add({
                        severity: Severity.Success,
                        summary: this.titlecasePipe.transform(Severity.Success),
                        detail: "Saved Successfully ...",
                    });
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("uplaodFile");
                    this.messageService.add({
                        severity: Severity.Error,
                        summary: this.titlecasePipe.transform(Severity.Error),
                        detail: "Error occurred ...",
                    });
                },
            });
    }
    setFormData(newFileList): any {
        const formData = new FormData();
        for (let file of newFileList) {
            formData.append("Files", file);
        }
        return formData;
    }
    delUpload(i) {
        this.documentsList.splice(i, 1);
    }
    removeFromUpload(file: File, uploader: FileUpload) {
        const index = uploader.files.indexOf(file);
        uploader.remove(null, index);
        this.newFileFolder.childFiles = [];
        this.newFileList = [];
        for (let file of uploader.files) {
            this.newFileFolder.childFiles.push(file);
            this.newFileList.push(file);
        }
        this.totalFileSize -= file.size;
        if (uploader.files.length < 6) {
            // this.maxNoOfFilesErrorMessage = [];
        }
        if (this.totalFileSize < 25000000) {
            // this.maxFilesizeErrorMessage = [];
        }
    }

    getGroupById(groupId) {
        this.purchaseService
            .getGroupById(groupId)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                this.valueOptions = res;
                this.selectedValueOption = this.valueOptions[0];
                this.expenseForm.controls.discountType.setValue(this.selectedValueOption);
            });
    }
    setAmountValue() {
        let total = Number(this.amountExpense) + Number(this.amountItem);
        this.expenseForm?.controls?.amount?.setValue(parseFloat(total.toFixed(this.fractionDigits)));
        this.convertNumToWords();
    }
    convertNumToWords() {
        this.numberInWords = this.ngxNumToWordsService.inWords(parseFloat(Number(this.expenseForm.controls.amount.value).toFixed(this.fractionDigits)), this.lang);
        this.expenseForm.controls.amountInWords.setValue(this.numberInWords);
    }
    openProducts(type?, bundle?) {
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.items;
        this.moduleName = "Kit";
        this.headerText = "Add Product";
    }
    onProductAddComplete(e) {
        this.items = _.cloneDeep(e);
        this.items?.forEach((e) => {
            if (e.typeId == TypeIds.BundleTypeId) {
                let bundleTotalCost = 0;
                for (let prd of e.bundleDetails) {
                    prd.ordQty = e?.ordQty * prd?.originalQty;
                    prd.cost = prd.costPrice * prd.ordQty;
                    bundleTotalCost += Number(prd.cost);
                }
                e.cost = bundleTotalCost;
            } else {
                e.cost = Number(e.costPrice) * Number(e.ordQty);
            }
        });
        this.selectedProductsList = [];
        this.calculateItemExpense();
        this.displayProductSelectionModal = false;
    }
    onProductCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }
    removeItem(index, type) {
        if (type == "item") {
            this.items.splice(index, 1);
            this.calculateItemExpense();
        } else {
            this.expenses.splice(index, 1);
            this.calculateExpense();
        }
    }
    calculateSubTotal(item, qty, price, bProduct?) {
        if (item.typeId != 4) {
            item.cost = price * qty;
        } else if (item.typeId == 4) {
            if (bProduct) {
                bProduct.cost = price * qty;
                let bundleTotalCost = 0;
                for (let prd of item.bundleDetails) {
                    bundleTotalCost += Number(prd.cost);
                }
                item.cost = bundleTotalCost;
            } else {
                let bundleTotalCost = 0;
                for (let prd of item.bundleDetails) {
                    prd.ordQty = item?.ordQty * prd?.originalQty;
                    prd.cost = prd.costPrice * prd.ordQty;
                    bundleTotalCost += Number(prd.cost);
                }
                item.cost = bundleTotalCost;
            }
        }
        this.calculateItemExpense();
    }
    calculateItemExpense(type?: typeFinanceAddEditViewText) {
        this.amountItem = 0;
        this.subTotal = 0;
        for (let itm of this.items) {
            this.subTotal = this.subTotal + Number(itm.cost);
        }
        if (this.subTotal == 0) {
            this.expenseForm.controls.freight.setValue(0);
            this.expenseForm.controls.discountAmount.setValue(0);
        }
        this.amountItem = this.subTotal + Number(this.expenseForm.controls.freight.value) - this.discount;
        this.findsum(type);
    }
    findsum(type?: typeFinanceAddEditViewText) {
        if (!this.expenseForm.controls.discountType.value) {
            this.expenseForm.controls.discountType.setValue(this.selectedValueOption);
        }

        if (this.type == "VIEW" || type == 'EDIT') {
            if (this.selectedValueOption?.name == "Percentage") {
                let dis = this.expenseDetails?.discountAmount > 0 ? (this.expenseDetails?.discountAmount / this.subTotal) * 100 : 0;
                this.expenseForm.controls.discountAmount.setValue(dis);
            } else if (this.selectedValueOption?.name == "Amount") {
                let dis = this.expenseDetails?.discountAmount;
                this.expenseForm.controls.discountAmount.setValue(dis);
            }
        }

        this.discount = 0;
        if (this.expenseForm?.controls?.discountType?.value?.name == "%" || this.expenseForm?.controls?.discountType?.value?.name == "Percentage") {
            this.discount = this.discount + Number(this.subTotal * (Number(this.expenseForm.controls.discountAmount.value) / 100));
        } else if (this.expenseForm?.controls?.discountType?.value?.name == "$" || this.expenseForm?.controls?.discountType?.value?.name == "Amount") {
            this.discount = this.expenseForm.controls.discountAmount.value;
        }
        this.amountItem = Number(this.subTotal + (this.subTotal > 0 ? Number(this.expenseForm.controls.freight.value) : 0) - this.discount);
        this.setAmountValue();
    }

    getAllDiscounts() {
        this.salesOrderService
            .getAllDiscount()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((res) => {
                if (res.item1) {
                    const discountsData = res.item2;
                    this.allDiscounts = discountsData.filter((d) => d?.name == "Manual");
                }
            });
    }

    loadFOBList() {
        this.fobService
            .getFOBList()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((points) => {
                if (points) {
                    this.allFOBPoints = points;
                }
            });
    }

    closeExpense() {
        this.updatedPostingPeriodInfo = null;
        this.close.emit();
    }

    onClose(type): void {
        this.accountForm.reset();
        this.expenseForm.reset();
        this.type = null;
        this.close.emit({ type: type });
    }

    onLocationSelect(e) {
        this.selectedLocation = e;
        this.selectedLocationId = this.selectedLocation?.id ?? 0;
    }

    async viewToEdit(expenseId: number) {
        if (expenseId > 0) {
            this.type = 'EDIT';
            await this.getExpenseDetailsById(expenseId);
        }
    }

    setEditExpenceTreeValue(expence: any[]) {
        expence.forEach(exp => {
            if (exp?.financialAccountId > 0) {
                let foundNode = this.financeUtilityService.findRecursiveChildObjects(this.financialAccounts, exp.financialAccountId);
                if (foundNode) {
                    exp.financialAccountId = foundNode;
                }
            }
        });
    }

    isTouched(formControlName: string): boolean {
        return this.expenseForm?.get(formControlName)?.touched;
    }

    hasRequiredError(formControlName: string): boolean {
        return this.expenseForm?.get(formControlName)?.hasError('required');
    }

    setBankTransactionOrderBundleProductsData(bProduct, type: typeFinanceAddEditViewText) {
        return (bProduct?.expenseTransactionOrderBundleProduct || []).map((product) => {
            const uomValue = product?.unit?.uomDetail?.value || 1;
            return {
                id: product?.subProductId || 0,
                warehouseId: product?.warehouseId || 0,
                typeId: product?.typeId || 0,
                itemNo: product?.itemNo || "",
                description: product?.description || "",
                ordQty: product?.quantity || 1,
                originalQty: product.originalQty,
                price: product?.pricePerProduct || 0,
                costPrice: product?.pricePerProduct || 0,
                cost: product?.totalAmount || 0,
                expenseTransactionOrderProductId: product?.expenseTransactionOrderProductId || 0,
                expenseTransactionId: product?.expenseTransactionId || 0,
                bundleDetails: this.setBankTransactionOrderBundleProductsData(product, type),
                expenseTransactionOrderProductBundleId: product?.id || 0
            };
        });
    }

    openFilePreview(file: any): void {
        this.documentService.getFileDownloadLinkById(file.attachmentId).subscribe((res) => {
            this.displayFilePreview = true;
            this.currentFile = res;
        });
    }

    closeFilePreview() {
        this.currentFile = null;
        this.displayFilePreview = false;
    }

    isClosingStatementDate(event: string) {
        this.statementMessage = event;
    }
   onPostingInfoChange(postingInfo: IPostingPeriodDetails) {
        this.updatedPostingPeriodInfo = postingInfo;
      }

    getIsetting() {
        this.appMainService.isShowSpinner("loadISettings");
        const iSettings = this.utilityService.getISettings();
        this.isAllowPostingPeriod = iSettings?.find(obj => obj.code === 'posting')?.enabled ?? false;
        this.appMainService.isHideSpinner("loadISettings");
    }
}
